import placeholderTemple from '../../assets/icons/temple.svg'
import placeHolderGames from '../../assets/icons/games.svg'

export default {
  placeholderTemple,
  placeHolderGames,
}

export { default as MenuStories } from '../../assets/icons/mainNavIcons/MenuStories'
export { default as MenuFeed } from '../../assets/icons/mainNavIcons/MenuFeed'
export { default as MenuTemple } from '../../assets/icons/mainNavIcons/MenuTemple'
export { default as MenuActivities } from '../../assets/icons/mainNavIcons/MenuActivities'
export { default as MenuMore } from '../../assets/icons/mainNavIcons/MenuMore'
